module.exports = __webpack_public_path__ + "static/media/carplife-fishomania.22ec6e9c.webp";